export const normalizeKey = (key: string | null): string | null => {
  if (
    !key ||
    key.trim() === "" ||
    key.trim().toLowerCase() === "undefined" ||
    key.trim().toLowerCase() === "null"
  ) {
    return null;
  }
  try {
    const parsed = JSON.parse(key);
    return typeof parsed === "string" && parsed.trim() !== "" ? parsed : key;
  } catch {
    return key;
  }
};
